import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractDocumentViewComponent } from '../abstract-document-view/abstract-document-view.component';
import {
  FidjiDocumentWebService,
  FidjiNatifLibraryService,
  FidjiDocumentActionNatifService,
  IMPublication} from '@immanens-com/fidji-api-module';
import {PublicationControllerService} from '../../../core/services/publication/publication-controller.service';
import {DomSanitizer} from '@angular/platform-browser';
import {UserControllerService} from '../../../core/services/user/user-controller.service';
import {DocumentControllerService} from '../../../core/services/document/document-controller.service';
import {Router} from '@angular/router';
import {loaderAnimation, thumbAnimation, loaderHeightAnimation} from '../../animations/document-thumb.animation';

@Component({
  selector: 'app-document-screen',
  templateUrl: './document-screen.component.html',
  styleUrls: ['./document-screen.component.scss'],
  animations: [thumbAnimation, loaderAnimation, loaderHeightAnimation],
  encapsulation : ViewEncapsulation.None // otherwise it seems we have conflicts with bootstrap
})
export class DocumentScreenComponent extends AbstractDocumentViewComponent implements OnInit {

  public docHasXML = false;
  public docSamplerLink = '';
  protected coverSize = 'medium';

  constructor(protected documentWS: FidjiDocumentWebService,
              protected publicationCtrl: PublicationControllerService,
              protected libraryService: FidjiNatifLibraryService,
              protected documentAction: FidjiDocumentActionNatifService,
              protected sanitizer: DomSanitizer,
              protected documentCtrl: DocumentControllerService,
              protected userControllerService: UserControllerService,
              protected router: Router) {
    super(libraryService, documentAction, sanitizer, documentCtrl, userControllerService);
  }

  protected prepareComponent() {

    // check whether the document has XML available or not
    this.docHasXML = this.documentInput.doc_enrichment !== undefined && this.documentInput.doc_enrichment.indexOf('xml') > -1;

    this.publicationCtrl.publicationByDocument(this.documentInput.dly_doc_id).subscribe((publication) => {
      this.setSamplerLink(publication);
    });

  }

  private setSamplerLink(publication: IMPublication) {
    if (
      publication != null &&
      publication.doc_data.hasOwnProperty('has_pv_sampler') &&
      publication.doc_data.has_pv_sampler === true
    ) {
      this.documentWS.getDocumentSampler(publication.pub_puc, this.documentInput.doc_number).subscribe(
        (docpreview) => {
          this.docSamplerLink = docpreview.url + '&context=inapp'; // context is temporary
        });
    } else if (this.documentInput.doc_summary_pages.length > 0) {
        this.docSamplerLink = 'local://' + 'gettoc/' + 'dly-doc-id/' + this.documentInput.dly_doc_id + '/toc.jpg';
      }
  }

  public clickXML() {
    // TODO
  }

  public clickExtract() {
    if (this.documentInput.doc_summary_pages.length > 0) {
      this.documentAction.summaryNativeAction(this.documentInput);
      return;
    }
    // else
    // window.open(this.docSamplerLink, '_blank');
    location.href = this.docSamplerLink;
  }

  public clickCover() {
    if (this.documentInput !== undefined) {
      this.documentAction.mainNativeAction(this.documentInput);
    }
  }

  public clickCancelDownload() {
    const document = this.libraryService.documentInLibraryFor(this.documentInput);
    this.documentAction.secondNativeAction(document);
  }

  public clickDeleteDocument() {
    const document = this.libraryService.documentInLibraryFor(this.documentInput);
    this.documentAction.secondNativeAction(document);
  }

  public clickDownload() {
    if (this.documentInput && this.userIsLogged) {
      this.documentAction.mainNativeAction(this.documentInput);
    }
  }

  public clickRead() {
    if (this.documentInput) {
      this.documentAction.mainNativeAction(this.documentInput);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/document-view/document-screen/document-screen.component.ts